module.exports = __webpack_public_path__ + "img/kommune-1245.7b12edac.svg";